import { Candle } from '../screens/Detail/types';

const findCandleStartTimestamp = (timestamp: number, data: Candle[]) =>
  data.find((d) => d.startTimestamp <= timestamp && timestamp <= d.endTimestamp)
    ?.startTimestamp ?? timestamp;

export const calculateStartOfWaveTimestamp = (
  timestamp: number,
  heikinCandles: Candle[],
  orderType: string | undefined,
) => {
  if (!heikinCandles?.length) {
    return timestamp;
  }

  const candleStartTimestamp = findCandleStartTimestamp(
    timestamp,
    heikinCandles,
  );

  const candleIndex = heikinCandles.findIndex(
    (c) => c.startTimestamp === candleStartTimestamp,
  );

  if (candleIndex === -1) {
    return timestamp;
  }

  /** Find the first heikinCandle with a startOfTrends true */
  let startOfWaveCandle;

  for (let index = candleIndex; index >= 0; index--) {
    const candle = heikinCandles[index];
    const isSameDirection =
      candle.direction === (orderType === 'BUY' ? 'up' : 'down');

    if (
      index === 0 &&
      startOfWaveCandle === undefined &&
      (!orderType || isSameDirection)
    ) {
      startOfWaveCandle = candle;
      break;
    }

    if (candle.startOfNewTrend && isSameDirection) {
      startOfWaveCandle = candle;
      break;
    }
  }

  return startOfWaveCandle?.startTimestamp || 0;
};
